let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hbn7C")).then(() => parcelRequire('9Blvx'));